import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Text} from '@/components/ui/text/Text'
import {WarningLabel} from '@/components/ui/warning-label/WarningLabel'
import {useTranslation} from '@/translations/i18n'

export const ProjectPathologiesDetailsEmptyCard = ({
    isLoading,
    showStartDate,
    isMainPathologies
}: {
    isLoading?: boolean
    showStartDate?: boolean
    isMainPathologies?: boolean
}) => {
    const {t} = useTranslation()
    return (
        <Flexbox direction="column" gap={2} fullWidth>
            {Array.from({length: isLoading ? 2 : 1}).map((_, index) => (
                <Grid columns={4} gap={2} fullWidth key={index}>
                    <GridItem spanColumn={3} direction="column" gap={2}>
                        <Text size="textSm" palette="neutral" shade="500" weight="400">
                            {t('projects:pathology')}
                        </Text>
                        {isLoading ? (
                            <Skeleton height={20} width="100%" />
                        ) : isMainPathologies ? (
                            <WarningLabel text={t('users:to_compile')} />
                        ) : (
                            <Text size="textSm" weight="500">
                                -
                            </Text>
                        )}
                    </GridItem>
                    {showStartDate && (
                        <GridItem spanColumn={1} direction="column" gap={2}>
                            <Text size="textSm" palette="neutral" shade="500" weight="400">
                                {t('projects:start_date')}
                            </Text>
                            {isLoading ? (
                                <Skeleton height={20} width="100%" />
                            ) : (
                                <Text size="textSm" weight="500">
                                    -
                                </Text>
                            )}
                        </GridItem>
                    )}
                </Grid>
            ))}
        </Flexbox>
    )
}
